<div class="container">
  <span class="title">סוג העוגן</span>
  <mat-button-toggle-group appearance="standard" [(ngModel)]="selectedAnchorType" (change)="selectAnchorType($event.value)">
    @for (anchorType of anchorTypeList(); track anchorType) {
      <mat-button-toggle
        [value]="anchorType"
        >{{ anchorType.anchorTypeLabel }}</mat-button-toggle
        >
      }
    </mat-button-toggle-group>
  </div>
